import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { history, useIntl } from 'umi';
import { Progress, Table } from 'tea-component';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Stats.scss';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/index.scss';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import AppAnnie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import npd from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import StatsExpandtable from '@/pages/intelligence/pages/MarketProfile/TabDetails/components/StatsExpandtable';
const { scrollable, pageable } = Table.addons;

export default function GenreTable(props: any) {
  const {
    countryId,
    showTableData,
    changeTableSort,
    sortColunms,
    gameType,
    selectedKeys,
    selectedAllKeys,
    changeSelectedKeys,
    changeSelectedKeysColor,
    onPagingChange,
    dataType,
    tableLength,
    pageSize,
    pageIndex,
  } = props;

  // console.log('GenreTable', props);

  const { formatMessage } = useIntl();
  const color = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];
  const pcColor = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];

  const tableColumns = [
    {
      key: 'select',
      width: 37,
      fixed: 'left',
      header: () => {
        return (
          <TableCheckboxHeader
            selectList={selectedKeys}
            tableSelectionAll={selectedAllKeys}
            onChange={(list, type) => {
              if (type == 'all') return;
              changeSelectedKeysColor({});
              selectedKeys.length = 0;
              changeSelectedKeys([...selectedKeys]);
            }}
          />
        );
      },
      render: (cvm: any) => {
        return (
          <TableCheckboxRender
            selectList={selectedKeys}
            cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
            onChange={(list, status) => {
              changeSelectedKeys(list);
              const selectedKeysColorTemp = [] as any;

              list.forEach((item, index) => {
                if (list.length < 6) {
                  let itemColor = '';
                  if (gameType == 'mobile') {
                    itemColor = color[index];
                  } else {
                    itemColor = pcColor[index];
                  }
                  selectedKeysColorTemp[item.app_id] = itemColor;
                }
              });
              changeSelectedKeysColor(selectedKeysColorTemp);
            }}
          />
        );
      },
    },
    {
      key: 'title',
      header: (
        <div className="dbi-firstRow-flex">
          <span className="dbi-text-id">#</span>
          <span>{formatMessage({ id: 'dbi_label_genre' })}</span>
        </div>
      ),
      fixed: 'left',
      render: (cvm: any) => (
        <div className="dbi-firstRow-flex">
          <span className="dbi-text-id"></span>
          <span>{cvm?.displayName || cvm?.name}</span>
        </div>
      ),
    },
    {
      key: 'revenue',
      align: 'right',
      // header: <SortBy title={'Revenue($)'} svgIcon={AppAnnie} />,
      header: (
        <SortBy
          type="font_sort"
          title={
            gameType === 'mobile'
              ? formatMessage({ id: 'dbi_revenue_$' })
              : formatMessage({ id: 'dbi_metric_digitalRevenue' })
          }
          svgIcon={gameType === 'mobile' ? AppAnnie : mscience32}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={
                gameType === 'mobile'
                  ? formatMessage({ id: 'dbi_revenue_$' })
                  : formatMessage({ id: 'dbi_metric_digitalRevenue' })
              }
              metric={gameType === 'mobile' ? 'appannie' : 'mscience'}
              metricKey={gameType === 'mobile' ? 'revenue' : 'digitalRevenue'}
              entityType={gameType}
            />
          }
          content={
            gameType === 'mobile' ? (
              <div style={{ maxWidth: '418px' }}>
                {formatMessage({ id: 'dbi_info_sum_selected' })}
                <br />
                {formatMessage({ id: 'dbi_info_revenue_removed' })}
                <br />
                {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
              </div>
            ) : (
              formatMessage({ id: 'dbi_info_sum_selected' })
            )
          }
          list={[
            {
              key: gameType === 'mobile' ? 'genreMobileRevenue' : 'genreDigitalRevenue',
              text:
                gameType === 'mobile'
                  ? formatMessage({ id: 'dbi_revenue_$' })
                  : formatMessage({ id: 'dbi_metric_digitalRevenue' }),
              title:
                gameType === 'mobile'
                  ? formatMessage({ id: 'dbi_revenue_$' })
                  : formatMessage({ id: 'dbi_metric_digitalRevenue' }),
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <div className="">
          {formatNum(cvm[gameType === 'mobile' ? 'revenue' : 'revenueDigital'], true)}
        </div>
      ),
    },
    {
      key: 'revenueChange',
      align: 'right',
      header: `${formatMessage({ id: 'dbi_market_percent' })} ${
        gameType === 'mobile'
          ? formatMessage({ id: 'dbi_revenue' })
          : formatMessage({ id: 'dbi_metric_digitalRevenueNoDo' })
      }`,
      render: (cvm: any) => (
        <Progress
          className="tabdetails-progress"
          type="circle"
          percent={Math.floor(
            (cvm[gameType === 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] * 10000) / 100,
          )}
          strokeWidth={8}
          strokeColor="#376AE7"
        />
      ),
    },
    {
      key: 'download',
      align: 'right',
      // header: <SortBy title={'Avg MAU'} svgIcon={AppAnnie} />,
      header: (
        <SortBy
          type="font_sort"
          title={
            gameType === 'mobile'
              ? formatMessage({ id: 'dbi_downloads' })
              : formatMessage({ id: 'dbi_metric_physical_revenue' })
          }
          svgIcon={gameType === 'mobile' ? AppAnnie : npd}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={
                gameType === 'mobile'
                  ? formatMessage({ id: 'dbi_downloads' })
                  : formatMessage({ id: 'dbi_metric_physical_revenue' })
              }
              metric={gameType === 'mobile' ? 'appannie' : 'npd'}
              metricKey={gameType === 'mobile' ? 'download' : 'physical_revenue'}
              entityType={gameType}
            />
          }
          content={
            gameType === 'mobile' ? (
              <>
                {formatMessage({ id: 'dbi_info_sum_selected' })}
                <br />
                {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
              </>
            ) : (
              <>{formatMessage({ id: 'dbi_info_sum_selected' })}</>
            )
          }
          list={[
            {
              key: gameType === 'mobile' ? `genreMobileDownloads` : `genrePhysicalRevenue`,
              text:
                gameType === 'mobile'
                  ? formatMessage({ id: 'dbi_downloads' })
                  : formatMessage({ id: 'dbi_metric_physical_revenue' }),
              title:
                gameType === 'mobile'
                  ? formatMessage({ id: 'dbi_downloads' })
                  : formatMessage({ id: 'dbi_metric_physical_revenue' }),
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <div className="">
          {gameType === 'mobile'
            ? formatNum(cvm.download, true)
            : countryId == 'us'
            ? formatNum(cvm.revenuePhysical, true)
            : '-'}
        </div>
      ),
    },
    {
      key: 'downloadChange',
      align: 'right',
      header: `${formatMessage({ id: 'dbi_market_percent' })} ${
        gameType === 'mobile'
          ? formatMessage({ id: 'dbi_downloads' })
          : formatMessage({ id: 'dbi_metric_physical_revenue1' })
      }`,
      render: (cvm: any) =>
        gameType === 'mobile' ? (
          <Progress
            className="tabdetails-progress"
            type="circle"
            percent={Math.floor((cvm.downloadChange * 10000) / 100)}
            strokeWidth={8}
            strokeColor="#376AE7"
          />
        ) : countryId == 'us' ? (
          <Progress
            className="tabdetails-progress"
            type="circle"
            percent={Math.floor((cvm.revenuePhysicalChange * 10000) / 100)}
            strokeWidth={8}
            strokeColor="#376AE7"
          />
        ) : (
          '-'
        ),
    },
  ];

  return (
    <StatsExpandtable
      gameType={gameType}
      tableData={{
        cvmList: showTableData,
        addons: [
          pageable({
            recordCount: dataType == 'game' ? tableLength : showTableData?.length || 0,
            isPagingReset: true,
            stateText: `Total items: ${
              dataType == 'game' ? tableLength : showTableData?.length || 0
            }`,
            pageSizeOptions: dataType == 'operation' ? [5, 10, 20] : [10, 20, 50],
            // pageCountChangingResetType: 'last',
            pageSize,
            pageIndex,
            onPagingChange,
          }),
        ],
        columns: tableColumns,
      }}
    />
  );
}
